import Flickity from 'flickity';
import { gsap } from '../global/gsap';

const initCarousels = (elements) => {
    elements.forEach((element) => {
        let align = 'center';
        let dots = false;
        let gallerySize = true;

        if (element.dataset.align) {
            align = element.dataset.align;
        }

        if (element.dataset.dots) {
            dots = true;
        }

        if (element.dataset.nosize) {
            gallerySize = false;
        }

        const track = element.querySelector('.js-carousel-track');

        const flickityOptions = {
            cellAlign: align,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: dots,
            draggable: true,
            setGallerySize: gallerySize
        };

        const carousel = new Flickity(track, flickityOptions);

        // Dynamic text
        if (element.dataset.dynamicText) {
            const dynamicTitle = element.querySelector('.js-carousel-dynamic h3');
            const dynamicSubTitle = element.querySelector('.js-carousel-dynamic h4');
            const dynamicText = element.querySelector('.js-carousel-dynamic .rich-text');
            const slideEls = element.querySelectorAll('.js-carousel-item');

            const dynamicEls = [];

            if (dynamicTitle) {
                dynamicEls.push(dynamicTitle);
            }

            if (dynamicText) {
                dynamicEls.push(dynamicText);
            }

            if (dynamicSubTitle) {
                dynamicEls.push(dynamicSubTitle);
            }

            carousel.on('change', (index) => {
                gsap.to(dynamicEls, {
                    opacity: 0,
                    duration: 0.25,
                    onComplete: () => {
                        dynamicTitle.innerHTML = slideEls[index].dataset.title;
                        dynamicText.innerHTML = slideEls[index].dataset.text;

                        if (dynamicSubTitle) {
                            dynamicSubTitle.innerHTML = slideEls[index].dataset.subtitle;
                        }

                        gsap.to(dynamicEls, {
                            opacity: 1,
                            duration: 0.25,
                        });
                    }
                });
            });
        }

        // Dots
        const dotsEl = element.querySelector('.js-carousel-dots');

        if (dotsEl) {
            const buttons = dotsEl.querySelectorAll('button');

            carousel.on('change', (index) => {
                buttons.forEach((button) => {
                    button.classList.remove('active');
                });

                buttons[index].classList.add('active');
            });

            dotsEl.addEventListener('click', (event) => {
                if (event.target.classList.contains('dot')) {
                    carousel.select(event.target.dataset.count);
                }
            });
        }

        // Custom nav
        const next = element.querySelector('.js-carousel-next');
        const prev = element.querySelector('.js-carousel-prev');

        if (next) {
            next.addEventListener('click', () => {
                carousel.next(true, false);
            });
        }

        if (prev) {
            prev.addEventListener('click', () => {
                carousel.previous(true, false);
            });
        }

        // Counter stuff
        const counter = element.querySelector('.js-carousel-counter');

        if (counter) {
            const active = counter.querySelector('.active');

            carousel.on('change', (index) => {
                active.textContent = index + 1;
            });
        }

        // Disable click events on drag
        carousel.on('dragStart', () => carousel.slider.style.pointerEvents = 'none');
        carousel.on('dragEnd', () => carousel.slider.style.pointerEvents = 'auto');
    });
};

export { initCarousels as default };
